
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/Auth/Auth.san?lang=less&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./Auth.html');
        
        var script = require('./Auth.ts').default;
        module.exports = require('./Auth.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    